import { mString } from 'lib/helpers/utility';

import Badge from 'components/shared/Badge/Badge';
import Divider from 'components/shared/Divider/Divider';
import Typography from 'components/shared/Typography/Typography';

import { SUMMARY_BADGES } from '../lib/constants';

const SummaryRow = ({ label, value }) => (
  <div className="flex w-full items-center justify-between gap-3">
    <Typography variant="label" size="medium" weight="medium" color="neutral-600">
      {label}
    </Typography>
    <Typography variant="label" size="medium" weight="medium">
      {value}
    </Typography>
  </div>
);

const SummaryContent = ({
  amount,
  surchargeAmount = 0,
  gratuityAmount = 0,
  cardLabel,
  transactionId
}) => {
  const rows = [
    { label: 'Subtotal', value: mString(amount - surchargeAmount - gratuityAmount) },
    surchargeAmount > 0 && { label: 'Technology fee', value: mString(surchargeAmount) },
    gratuityAmount > 0 && { label: 'Gratuity', value: mString(gratuityAmount) },
    cardLabel && { label: 'Card on file', value: cardLabel },
    transactionId && { label: 'Payment ID', value: `#${transactionId}` }
  ].filter(Boolean);

  return (
    <>
      <div className="flex flex-col items-start gap-5 rounded-xl border-2 border-solid border-[rgba(255,255,255,0.8)] bg-white/40 px-6 pb-3 pt-6 shadow-[-2px_0px_7px_rgba(0,0,0,0.05),2px_4px_15px_rgba(0,0,0,0.07)] backdrop-blur-[1px] xs:px-4">
        <div className="flex w-full min-w-[140px] flex-col justify-center gap-3 rounded-xl">
          <div className="flex flex-col gap-2">
            <Typography variant="p" size="small" weight="semibold" color="primary-500">
              PAYMENT SUMMARY
            </Typography>
            <Typography
              variant="h3"
              color="primary-500"
              className="text-4xl font-extrabold sm:text-3xl">
              {mString(amount)}
            </Typography>
          </div>
          <Divider />
          <div className="flex flex-col items-end gap-5">
            {rows.map((row) => (
              <SummaryRow key={row.label} label={row.label} value={row.value} />
            ))}
          </div>
          <Divider />
          <div className="flex w-full items-center justify-between gap-3 py-[9px]">
            <Typography variant="p" size="small" weight="medium" color="neutral-800">
              Paid today
            </Typography>
            <Typography variant="label" size="medium" weight="semibold">
              {mString(amount)}
            </Typography>
          </div>
        </div>
      </div>
      <div className="flex shrink-0 flex-wrap content-center items-center justify-center gap-[12px_8px] pb-2">
        {SUMMARY_BADGES.map((badge) => (
          <Badge key={badge.id} icon={badge.icon} text={badge.text} color="neutral" />
        ))}
      </div>
    </>
  );
};

export default SummaryContent;
